import { StoreFont } from '@/types';
import { StoreState } from '@/redux/types';
import { getFonts } from './getFonts';

export const findFont = (
  state: StoreState,
  fontFamilyName: string,
  fontStyle = 'normal',
  fontWeight = 'normal'
): StoreFont | undefined => {
  const fontFamily = getFonts(state).find((f) => f.name === fontFamilyName);
  if (fontFamily) {
    return (
      fontFamily.fonts.find((f) => f.weight === fontWeight && f.style === fontStyle) ||
      fontFamily.fonts[0]
    );
  }
};
